class ProductHighPerformanceIngredients extends HTMLElement {
  constructor() {
    super();
  }

  // Lifecycle method called when the element is inserted into the DOM.
  connectedCallback() {
    this.section = this;
    this.swiperEl = this.section.querySelector(".swiper");
    this.pagination = this.section.querySelector(".swiper-pagination");
    this.counterImages = this.section.querySelectorAll(".swiper-slide").length;
    if (this.counterImages > 1) this.buildSlider();
  }

  // Lifecycle method called when the element is removed from the DOM.
  disconnectedCallback() {
    this.showClearformeIngredientsBtn.removeEventListener(
      "click",
      this.showClearformeIngredients.bind(this),
      true
    );
  }

  /**
   * Builds the image slider using the Swiper library.
   * Imports the Swiper module dynamically and initializes the slider.
   */
  buildSlider() {
    import(flu.chunks.swiper).then((_ref) => {
      let { Swiper, Pagination } = _ref;
      this.slider = new Swiper(this.swiperEl, {
        modules: [Pagination],
        slidesPerView: 1,
        spaceBetween: 4,
        resistance: false,
        loop: true,
        pagination: {
          el: this.pagination,
          type: "bullets",
          bulletElement: "span",
          bulletClass: "swiper-pagination-bullet",
          clickable: true,
        },
      });
    });
  }
}
customElements.define(
  "product-high-performance-ingredients",
  ProductHighPerformanceIngredients
);
